import { useState } from "react";
import { Link } from "react-router-dom";
import { GLOSSARY } from "@/data/glossary";
import { useAcademy } from "@/context/AcademyContext";
import { Card } from "@/components/ui-kit";
import { Input } from "@/components/ui/input";
import { ArrowLeft, BookOpen, Search } from "lucide-react";

export default function Glossary() {
  const { t } = useAcademy();
  const [q, setQ] = useState("");
  const filtered = GLOSSARY.filter((g) =>
    (g.term + " " + (g.full || "") + " " + g.def).toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="space-y-5 ngx-fade-in max-w-4xl mx-auto" data-testid="glossary-page">
      <Link to="/academy" data-testid="glossary-back" className="flex items-center gap-2 text-sm text-slate-400 hover:text-slate-100">
        <ArrowLeft className="h-4 w-4" /> {t("backToAcademy")}
      </Link>
      <div className="flex items-center gap-3">
        <div className="h-11 w-11 rounded-md bg-blue-600/15 border border-blue-800 flex items-center justify-center">
          <BookOpen className="h-5 w-5 text-blue-400" />
        </div>
        <div>
          <h1 className="font-display text-2xl font-bold text-slate-50">{t("glossary")}</h1>
          <p className="text-sm text-slate-400">{t("glossarySubtitle")}</p>
        </div>
      </div>

      <div className="relative">
        <Search className="h-4 w-4 text-slate-500 absolute left-3 top-1/2 -translate-y-1/2" />
        <Input data-testid="glossary-search" value={q} onChange={(e) => setQ(e.target.value)}
          placeholder={t("searchTerms")}
          className="pl-9 h-11 bg-[#0A1128] border-slate-700 text-slate-100" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="glossary-list">
        {filtered.map((g) => (
          <Card key={g.term} className="p-4">
            <div className="flex items-baseline gap-2">
              <span className="font-mono text-blue-400 font-semibold">{g.term}</span>
              {g.full && <span className="text-xs text-slate-500">{g.full}</span>}
            </div>
            <p className="text-sm text-slate-300 mt-1.5 leading-relaxed">{g.def}</p>
          </Card>
        ))}
        {filtered.length === 0 && <div className="col-span-2 text-center text-slate-500 py-10">No terms found.</div>}
      </div>
    </div>
  );
}
